"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Classroom = void 0;
var lodash_1 = require("lodash");
var account_1 = require("../../account");
var school_1 = require("../../school");
var meeting_1 = require("../meeting");
var user_service_1 = require("../user-service");
var classroom_participant_1 = require("./classroom-participant");
var properties = ['id', 'author_id', 'author', 'user_service_id', 'user_service', 'user_service_contract_id', 'user_service_contract', 'school_id', 'school', 'slug', 'title', 'cover_id', 'cover', 'description', 'type', 'participants', 'created_at', 'archived_at', 'stats', 'visit_info', 'purl', 'can', 'last_meeting_id', 'last_meeting', 'next_meeting_id', 'next_meeting', 'access'];
var dateProperties = ['created_at', 'archived_at'];
/** Классная комната */
var Classroom = /** @class */function () {
  function Classroom(values) {
    if (values === void 0) {
      values = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var instance = this;
    (0, lodash_1.assign)(instance, (0, lodash_1.pick)(values, properties));
    // преобразование дат
    dateProperties.forEach(function (p) {
      if (p in instance && instance[p]) {
        instance[p] = new Date(instance[p]);
      }
    });
    if ('author' in values) {
      instance.author = new account_1.User(values.author);
    }
    if ('school' in values) {
      instance.school = new school_1.CSchool(values.school);
    }
    if ('user_service' in values) {
      instance.user_service = new user_service_1.UserService(values.user_service);
    }
    if ('user_service_contract' in values) {
      instance.user_service_contract = new user_service_1.UserServiceContract(values.user_service_contract);
    }
    if ('last_meeting' in values) {
      instance.last_meeting = new meeting_1.Meeting(values.last_meeting);
    }
    if ('next_meeting' in values) {
      instance.next_meeting = new meeting_1.Meeting(values.next_meeting);
    }
    instance.participants = (values.participants || []).map(function (p) {
      return new classroom_participant_1.ClassroomParticipant(p);
    });
  }
  /** Классная школа для какой-либо школы */
  Classroom.IN_ANY_SCHOOL = true;
  /** Классная школа ВНЕ какой-либо школы */
  Classroom.OUT_OF_ANY_SCHOOL = false;
  return Classroom;
}();
exports.Classroom = Classroom;
